var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-jifens",class:[_vm.size ? _vm.size : '']},[_c('i',{staticClass:"icons icon-jifen-v"}),_vm._v(_vm._s(_vm.points)),_c('span',[_vm._v(_vm._s(_vm.text == 'no' ? '' : '积分'))])])}
var staticRenderFns = []

export { render, staticRenderFns }